import { useEffect, useState } from 'react';
import ReportFilter from '../../components/reportFilter';
import TimeOnTaskReport from '../../../../components/TimeOnTaskReport';
import { useReportContext } from '../../components/reportContext';
import { useGetTimeOnTaskPersistMutation, useUpdateTimeOnTaskPersistMutation } from '../../../../features/authentication/persistApiSlice';

const TTReport = () => {
  const [getTimeOnTaskPersist] = useGetTimeOnTaskPersistMutation();
  const [updateTimeOnTaskPersist] = useUpdateTimeOnTaskPersistMutation();
  const {assignmentId, setAssignmentId, includeRetakes, setIncludeRetakes, selectedClassId, setSelectedClassId, selectedStudentId, setSelectedStudentId, studentName , selectedCourseId, setSelectedCourseId, startDate, setStartDate,
    endDate, setEndDate, isAllReport, setIsAllReport, studentToIncludeTab, setStudentToIncludeTab, className, courseName, setIsAssessment} = useReportContext();
  const [showReport, setShowReport] = useState(false);
  const [, setPersistValues] = useState(null);

  const handleCreateReport=()=>{
    setShowReport(true);
    handleUpdateTimeOnTaskPersist();
  };

  useEffect(() => {
    getPersistData();
  }, []);


  const getPersistData = async ()=>
  {
    var persistData =await getTimeOnTaskPersist().unwrap();
    setPersistValues(persistData);
    setSelectedCourseId(persistData.courseId);
    setSelectedClassId(persistData.classId);
    setStartDate(persistData.startDate);
    setEndDate(persistData.endDate);
    setIncludeRetakes(persistData.includeRetakes);
    setAssignmentId(persistData.assignmentId);
    setIsAllReport(persistData.isAllReport);
    setSelectedStudentId(persistData.studentId);
    setStudentToIncludeTab(persistData.studentToInclude);
    setIsAssessment(false);
  };

  const handleUpdateTimeOnTaskPersist = async ()=>{
    var options={
      'courseId': selectedCourseId,
      'isAllReport': isAllReport,
      'assignmentId': assignmentId,
      'startDate': startDate,
      'endDate': endDate,
      'studentToInclude': studentToIncludeTab,
      'studentId': selectedStudentId,
      'classId': selectedClassId,
      'includeRetakes': includeRetakes
    };
    await updateTimeOnTaskPersist(options);
  };

  return (
    <>
      {!showReport && <div>
        <ReportFilter
          handleCreateReport={handleCreateReport}
          isTOTReport={true}
          backOnClick={()=>setShowReport(false)}
          description={'Activity Tracking reports on student activity for individual assignments or for all assignments in a course (currently assigned and unassigned). Note that only assignments or self study assignments that were taken with Time On Task enabled will show up.'}
          type={'time-on-task-tracking'}
          title={'Time On Task Tracking Report'} />
      </div>}

      {showReport &&
           <div id="reportWrapper">
             <TimeOnTaskReport 
               assignmentId={isAllReport? -1 : assignmentId}
               includeRetakes={includeRetakes}
               isFromTeacherReport={true}
               classId={selectedClassId==0?-1:selectedClassId}
               className={className}
               courseId={selectedCourseId}
               courseName={courseName}
               studentId={studentToIncludeTab !=2? -1:selectedStudentId}
               studentName={studentName}
               startDate={startDate}
               endDate={endDate}
               studentToInclude={studentToIncludeTab}
               backButtonOnClick={()=>{setShowReport(false);}}
               isLoginActivityReport={false} />
           </div>
      }
    </>
  );
};

export default TTReport;